<template>
  <BaseModal
    :show="isOpen"
    size="xs"
    :title="t('app.views.cashRegister.openSession') || 'Open Session'"
    :show-actions="true"
    :save-text="t('app.views.cashRegister.openSession') || 'Open session'"
    @close="$emit('close')"
    @save="handleSave"
  >
    <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
      {{ t('app.views.cashRegister.initialBalance') || 'Initial Balance' }}
    </label>
    <input 
      v-model="localBalance" 
      type="number" 
      step="0.01"
      class="w-full rounded-md border border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
    >
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseModal from '@/components/common/BaseModal.vue';

const { t } = useI18n();

const props = defineProps<{
  isOpen: boolean;
  initialBalance: number;
}>();

const emit = defineEmits<{
  close: [];
  save: [balance: number];
}>();

const localBalance = ref(props.initialBalance);

watch(() => props.initialBalance, (newVal) => {
  localBalance.value = newVal;
});

const handleSave = () => {
  emit('save', localBalance.value);
};
</script>
